import { connect } from 'react-redux';
import { fetchSingleProduct } from '../../../../../../store/products/actions';
import { setOpenModal } from '../../../../../../store/modals/actions';
import TableContent from './TableContent';

const mapDispatchToProps = (dispatch) => ({
  fetchSingleProduct: (productId) => dispatch(fetchSingleProduct(productId)),
  setOpenModal: (modal, value) => dispatch(setOpenModal(modal, value)),
});

export default connect(null, mapDispatchToProps)(TableContent);
